// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"4bbf1903","164":"0d3a4233","246":"2bb52f6f","255":"09bfe6ea","531":"37aa05a0","806":"5f29b61a","844":"80d6b1f1"}[chunkId] + ".chunk.css";
};